import React from 'react';

import { IconButton, Stack, styled } from '@mui/material';

import { IconSizes, NavigateBeforeIcon, NavigateNextIcon } from '@libs/shared/ui/icons';

import { useDesktopFullscreen } from './desktop-fullscreen-context';

const SwitcherContainer = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
`;

const NavigationButton = styled(IconButton)`
  color: ${props => props.theme.palette.grey[600]} !important;
  background-color: ${props => props.theme.palette.grey[200]} !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;

  &:hover {
    background-color: ${props => props.theme.palette.grey[300]} !important;
  }

  &:disabled {
    background-color: ${props => props.theme.palette.grey[100]} !important;
    opacity: 0.5;
  }
`;

export interface DesktopSwitcherProps {
  showSwitcher: boolean;
}

export const DesktopSwitcher: React.FC<DesktopSwitcherProps> = ({ showSwitcher }) => {
  const { totalDesktops, canSwitch, switchToPrevious, switchToNext } = useDesktopFullscreen();

  if (!showSwitcher || totalDesktops === 0) {
    return null;
  }

  return (
    <SwitcherContainer>
      <NavigationButton
        size="small"
        onClick={switchToPrevious}
        disabled={!canSwitch}
        title="Previous desktop (Ctrl+←)"
        aria-label="Switch to previous desktop"
      >
        <NavigateBeforeIcon fontSize={IconSizes.small} />
      </NavigationButton>

      <NavigationButton
        size="small"
        onClick={switchToNext}
        disabled={!canSwitch}
        title="Next desktop (Ctrl+→)"
        aria-label="Switch to next desktop"
      >
        <NavigateNextIcon fontSize={IconSizes.small} />
      </NavigationButton>
    </SwitcherContainer>
  );
};
